import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { User } from 'src/types/shared/User';

export const fetchAllUsersRequest = createAction('fetchAllUsersRequest');
export const fetchAllUsersSuccess = createAction<User[]>('fetchAllUsersSuccess');
export const fetchAllUsersFailure = createAction('fetchAllUsersFailure');

export const fetchAllUsers = () => async (dispatch: AppDispatch): Promise<void> => {
    dispatch(fetchAllUsersRequest());
    try {
        const { data }: Response = await api.get('admin/users');
        dispatch(fetchAllUsersSuccess(data));
    } catch (e) {
        handleApiErrors(dispatch, fetchAllUsersFailure, e);
    }
};

interface Response {
    data: User[];
}
